import { render } from "./IconUsers.vue?vue&type=template&id=189b974d"
const script = {}

import exportComponent from "/mnt/c/Users/mssuzuki/work/fidev/nicotto/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__